export const DESCRIPTION = 'DESCRIPTION';
export const DESCRIPTIONSM = 'DESCRIPTIONSM';
